/* eslint-disable react/require-default-props */
import React from 'react';
import ReactPlayer from 'react-player';
import { Progress } from '../../interface';

interface PlayerProps {
  isPlaying: boolean;
  playerRef?: React.Ref<ReactPlayer>;
  progressHandler: (progress: Progress) => void;
  handleIsPlaying: (isPlaying: boolean) => void;
  loop: boolean;
  url:string
  volume: number;
  playbackRate: number;
}

const VideoPlayer = ({
  isPlaying, playerRef, progressHandler, handleIsPlaying, loop, url, volume, playbackRate,
}:PlayerProps) => (
  <>
    {/* <React.StrictMode> */}

    <ReactPlayer
      url={url}
      ref={playerRef}
      width={url.includes('youtube.com') || url.includes('youtu.be') ? '100%' : 'auto'}
      height="100%"
      style={{ display: 'flex', maxHeight: '100%', objectFit: 'cover' }}
      playing={isPlaying}
      loop={loop}
      onProgress={progressHandler}
      progressInterval={1000}
      onEnded={() => {
        handleIsPlaying(false);
      }}
      volume={volume}
      playbackRate={playbackRate}
    />
    {/* </React.StrictMode> */}

    {/* <button type="button" onClick={() => ref?.current?.seekTo(10)}>Seek to 00:10</button> */}
  </>
);

export default VideoPlayer;
